/**
 * In many cases, such as selecting the schedule date for a task, the entire day
 * should be part of the date.
 */
export function includeHours(date) {
    const dateWithHours = new Date(date);
    dateWithHours.setHours(23, 59, 59, 0);

    return dateWithHours;
}
